const emailVerificationEnum = Object.freeze({
  NOT_VERIFIED: 0,
  SENT: 1,
  VERIFIED: 2
})

export { emailVerificationEnum }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/EmailVerificationEnum.js